/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }

  
}

/* gift wrap*/
document.body.addEventListener('change', function(e) {
   
  if (!e.target.classList.contains('gift_pdp')) return;

    const t = e.target.dataset.vid; 
    const properties = e.target.classList.contains('gift_wrapping')
        ? { "_no-free-gift": "true", _gift: "gift" }
        : { "_no-free-gift": "true", _gift_note: "gift_note" };

    const url = e.target.checked ? '/cart/add.js' : '/cart/update.js';
    const method = e.target.checked ? 'POST' : 'POST';
    const body = e.target.checked
        ? JSON.stringify({ id: t, quantity: 1, properties: properties })
       // : `updates[${t}]=0`;
      : JSON.stringify({ updates: {[t]: 0}});
   

    fetch(url, {
        method: method,
        headers: {
            'Content-Type': 'application/json'
        },
        body: e.target.checked ? body : body
    })
    .then(response => {
        if (!response.ok) {
            return response.json().then(err => {
                throw new Error(err.description);
            });
        }
        return response.json();
    })
    .then(data => {
        if (document.querySelector('.template-cart')) {
            location.reload();
        } else {
           this.querySelector('cart-form').refresh();  
        }
    })
    .catch(error => {
        alert(error.message);
    });
});

/* gift wrap */

window.customElements.define('cart-drawer', CartDrawer);
